import { getCurrentUser, setCurrentUser } from 'helpers/Utils';
import { isAuthGuardActive, currentUser } from 'constants/defaultValues';
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  LOGOUT_USER,
  OTP_SEND_CODE,
  OTP_SEND_CODE_SUCCESS,
  OTP_SEND_CODE_ERROR,
  RESET_FORM_DATA,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  CLEAN_MOBILE,
  CHANGE_MOBILE,
  UPDATE_USER_AUTH,

} from '../actions';

const INIT_STATE = {
  currentUser: isAuthGuardActive ? currentUser : getCurrentUser(),
  forgotUserMail: '',
  newPassword: '',
  resetPasswordCode: '',
  loading: false,
  error: '',
  reg_mobile: null,
  success: '',
  seconds: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_USER_AUTH: {
      const currentUser = getCurrentUser();
      setCurrentUser({ ...currentUser, ...action.payload });
      
      return { ...state, currentUser: action.payload }
    }
    case CHANGE_MOBILE:
      return { ...state, reg_mobile: action.payload.mobile };
    case CLEAN_MOBILE:
      return { ...state, reg_mobile: null };
    case RESET_FORM_DATA:
      return {
        ...state,
        mobile: null,
        forgotUserMail: '',
        newPassword: '',
        resetPasswordCode: '',
        loading: false,
        error: '',
        success: '',
        seconds: 0,
      }
    case OTP_SEND_CODE:
      return { ...state, loading: true, error: '', success: '', seconds: 0 };
    case OTP_SEND_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: '',
        success: action.payload.message,
        seconds: action.payload.seconds,
      };
    case OTP_SEND_CODE_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        success: '',
        error: action.payload.message,
        seconds: action.payload.seconds,
      };
    case LOGIN_USER:
      return { ...state, loading: true, error: '', success: '', seconds: 0 };
    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        currentUser: action.payload,
        error: '',
        success: '',
        seconds: 0,
      };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: action.payload.message,
      };
    // case FORGOT_PASSWORD:
    //   return { ...state, loading: true, error: '', success: '' };
    // case FORGOT_PASSWORD_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     forgotUserMail: action.payload,
    //     error: '',
    //     success: '',
    //   };
    // case FORGOT_PASSWORD_ERROR:
    //   return {
    //     ...state,
    //     loading: false,
    //     forgotUserMail: '',
    //     error: action.payload.message,
    //     success: '',
    //   };
    // case RESET_PASSWORD:
    //   return { ...state, loading: true, error: '', success: '' };
    // case RESET_PASSWORD_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     newPassword: action.payload,
    //     resetPasswordCode: '',
    //     error: '',
    //     success: '',
    //   };
    // case RESET_PASSWORD_ERROR:
    //   return {
    //     ...state,
    //     loading: false,
    //     newPassword: '',
    //     resetPasswordCode: '',
    //     error: action.payload.message,
    //     success: '',
    //   };
    case REGISTER_USER:
      return { ...state, loading: true, error: '', success: '' };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload.message,
        error: '',
      };
    case REGISTER_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        error: action.payload.message,
        success: '',
      };
    case LOGOUT_USER:
      return { ...state, currentUser: null, error: '', success: '' };
    default:
      return { ...state };
  }
};
